import {NotificationData, Observer} from '../Notifier';
import Status from '../Status';

export default class SiteAdminObserver implements Observer {
    status: string;
    actionHandler: Function;
    migrationItem: HTMLElement;
    migrationUpsellItem: HTMLElement;

    handleMigrationItemClick = (event: MouseEvent): void => {
        event.preventDefault();

        /** Bind the notification action that corresponds to each of the relevant statuses we need */
        switch  (this.getStatus()) {
            case Status.INITIAL:
            case Status.SKIPPED:
            case Status.SUCCESS:
                let actionHandler = this.getActionHandler();
                actionHandler();
                break;

            default:
                break;
        }
    };

    handleMigrationUpsellItemClick = (event: MouseEvent): void => {
        event.preventDefault();

        if (this.getStatus() === Status.UPGRADEABLE) {
            let actionHandler = this.getActionHandler();
            actionHandler();
        }
    };

    init() {
        this.migrationItem = document.getElementById('cc-sa-item-migration');
        this.migrationUpsellItem = document.getElementById('cc-sa-item-migration-upsell');
    }

    bindEvents() {
        /* Migration Siteadmin trigger */
        if (this.migrationItem !== null) {
            this.migrationItem.addEventListener('click', this.handleMigrationItemClick);
        }
        /* Migration Siteadmin Upsell trigger */
        if (this.migrationUpsellItem !== null) {
            this.migrationUpsellItem.addEventListener('click', this.handleMigrationUpsellItemClick);
        }
    }

    unbindEvents() {
        /* Migration Siteadmin trigger */
        if (typeof this.migrationItem !== 'undefined' && this.migrationItem !== null) {
            this.migrationItem.removeEventListener('click', this.handleMigrationItemClick);
        }
        /* Migration Siteadmin Upsell trigger */
        if (typeof this.migrationUpsellItem !== 'undefined' && this.migrationUpsellItem !== null) {
            this.migrationUpsellItem.removeEventListener('click', this.handleMigrationUpsellItemClick);
        }
    }

    notify(data: NotificationData) {
        this.setStatus(data.status);
        this.setActionHandler(data.actionHandler);

        if (typeof this.migrationItem === 'undefined' && typeof this.migrationUpsellItem === 'undefined') {
            this.init();
        }
        this.bindEvents();
    }

    remove() {
        this.unbindEvents();
    }

    getStatus(): string {
        return this.status;
    }

    setStatus(status: string): void {
        this.status = status;
    }

    getActionHandler(): Function {
        return this.actionHandler;
    }

    setActionHandler(actionHandler: Function): void {
        this.actionHandler = actionHandler;
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/externalwebsiteimport/NotifierObservers/SiteAdminObserver.ts
 **/